module.exports = __webpack_public_path__ + "fonts/363fd092-cd55-4bd1-bdc5-cfc9a7057517.c5a33156.eot";